import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(data) {
        const items = data.cart_data.items;
        const resultItems = data.result;

        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.cart_preview-items');
          itensCartPreview.innerHTML = '';

          items.forEach((item, index) => {
            let brandHtml = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';

            // ID correto que a API quer pra deletar (do result)
            const deleteId = resultItems[index]?.id;

            let itemHTML = `
              <li class="cart-item ${item.is_gift ? 'is-gift' : ''}">
                <figure>
                  <img src="${item.image_medium}" alt="${item.name}">
                </figure>
                <div class="cart-item-content">
                  ${brandHtml}
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                  <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
                  ${variations}
                  <button class="delete-item-button" data-original-id="${deleteId}"></button>
                  <div class="group-quantity">
                    <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                    <span class="qtd-value">${item.quantity}</span>
                    <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
                  </div>
                </div>
              </li>
            `;

            itensCartPreview.innerHTML += itemHTML;
          });

          document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
            el.textContent = String(data.result.length).padStart(2, '0');
          });

          document.querySelector('.total_value_cart_preview').textContent =
            new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);

          // Atualiza eventos dos botões
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function () {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });

          document.querySelectorAll('.btn-increase').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              
              updateItemQuantity(originalId, qtdAtual + 1);
            });
          });

          document.querySelectorAll('.btn-decrease').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              if (qtdAtual > 1) {
                updateItemQuantity(originalId, qtdAtual - 1);
              } else {
                deleteCartItem(originalId); // Lembra de adaptar a função de delete também, se ela mudar pra esse payload
              }
            });
          });
        }
      }

      function deleteCartItem(id) {
        $.ajax({
          type: 'DELETE',
          url: '/api/front/cart/items/remove',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify([{ id: id }])
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            reloadCartPreview();
            updateCartPreview(data);
          }
        }).fail(function (err) {
          console.error('Erro ao remover item do carrinho:', err);
        });
      }

      function updateItemQuantity(originalId, newQty) {
        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];

        $.ajax({
          type: 'POST',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify(payload)
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          var data = jqXHR.responseJSON;
  
          if (Array.isArray(data) && data.length > 0 && data[0].stock) {
            alert(`O produto <b>"${data[0].stock.product.name}"</b> possui <b>${data[0].stock.quantity}</b> unidade[s] em estoque.`);
          } else {
            alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
          }
        
          console.error('Erro ao atualizar quantidade:', errorThrown);
        });
      }

      function reloadCartPreview() {
        $.ajax({
          type: 'GET',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json'
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);

            document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
              el.textContent = String(data.result.length).padStart(2, '0');
            });

            document.querySelector('.total_value_cart_preview').textContent =
              new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);
          }
        });
      }

      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function (data) {
        if (data && data.cart_data && data.result) {
          updateCartPreview(data);
        }
      });

      $(document).on("ajaxComplete", function (event, xhr, settings) {
        try {
          const payload = JSON.parse(settings.data);
      
          const isReplacingQty = Array.isArray(payload) && payload[0]?.replace_quantity;
      
          if (
            settings.url.includes('/api/front/cart/items/?version=2') &&
            settings.type === 'POST' &&
            xhr.responseJSON &&
            Array.isArray(xhr.responseJSON.result)
          ) {
            reloadCartPreview();
      
            // Só abre o carrinho se não estiver atualizando a quantidade
            if (!isReplacingQty) {
              $('.cart-preview--overlay').addClass('active');
              $('.cart-preview').addClass('active');
              $('.shoppub-fast-buy-popup').removeClass('active');
              document.body.classList.toggle('no-scroll');
            }
          }
        } catch (e) {
          console.warn('Erro ao interpretar payload do AJAX:', e);
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  // Função para atualizar o conteúdo do cart preview
  function updateCartPreview() {
    let url = window.location.href;
    let domainMatch = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/img);
    let domain = domainMatch ? domainMatch[0] : '';

    let key = `cart-preview-cache-${domain}`;
    let value = sessionStorage.getItem(key);

    let cartPreview = document.querySelector('.cart-preview');
    if (cartPreview) {
      if (value !== null) {
        let ObjectValue = JSON.parse(value);
        let htmlItens = ObjectValue.html_itens;
        let itensCartPreview = document.querySelector('.cart_preview-items');
        itensCartPreview.innerHTML = htmlItens;
      } else {
        console.log("Não há valor armazenado para a chave fornecida.");
      }
    }
  }

  // Verifica se a sessionStorage é suportada pelo navegador
  if (typeof (Storage) !== "undefined") {
    // Sobrescreve o setItem para disparar um evento customizado
    (function() {
      var originalSetItem = sessionStorage.setItem;
      sessionStorage.setItem = function(key, value) {
        var event = new Event('storageChanged');
        event.key = key;
        event.newValue = value;
        window.dispatchEvent(event);
        originalSetItem.apply(this, arguments);
      }
    })();

    // Inicializa a atualização do conteúdo
    updateCartPreview();

    // Escuta o evento customizado
    window.addEventListener('storageChanged', function(e) {
      if (e.key && e.key.startsWith('cart-preview-cache-')) {
        updateCartPreview();
      }
    });
  } else {
    console.log("Desculpe, seu navegador não suporta sessionStorage.");
  }

  function imageLazyLoad() {
    const lazyImages = document.querySelectorAll('img.banner-lazy[data-src]');

    lazyImages.forEach(function(img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.classList.add('loaded');
    });
  }

  function loadSvg() {
      const svgs = document.querySelectorAll("[class^='no-svg-']");

      svgs.forEach(function(svg) {
          // Obtém a lista de classes como uma string
          var oldClasses = svg.getAttribute("class");

          // Substitui o prefixo 'no-svg-' por uma string vazia
          var newClasses = oldClasses.replace(/no-svg-/g, '');

          // Define as novas classes para o elemento SVG
          svg.setAttribute("class", newClasses);
      });
  }

  function imageLazyLoadMove() {
    const lazyImages = document.querySelectorAll('img.banner-lazy-move[data-move]');

    lazyImages.forEach(function(img) {
      img.src = img.getAttribute('data-move');
      img.removeAttribute('data-move');
      img.classList.add('loaded');
    });
  }

  window.addEventListener('mousemove', imageLazyLoadMove);

  function onFirstScroll() {
      imageLazyLoad();
      loadSvg();
      window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, {passive: true});

  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
    tabAccordion.addEventListener('click', function () {
      tabAccordions.forEach(function (tab) {
        tab.classList.remove('active');
      });

      contentAccordions.forEach(function (content) {
        content.classList.remove('active');
      });

      tabAccordion.classList.add('active');
      contentAccordions[index].classList.add('active');
    });
  });

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);

  const comunicado = document.querySelector('.comunicado');
  if (comunicado) {
    $('#carrousel-comunicado').slick({
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: true,
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      speed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        },
      ]
    });
  }

  const aboutThemes = document.querySelector('.about-themes');
  if (aboutThemes) {
    $('#carrousel-second-section').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        },
      ]
    });
  }

});

const pageExtraCarrosel = document.querySelector('#dynamic-page-extra .image-list');
if (pageExtraCarrosel) {
  $('#dynamic-page-extra .image-list').slick({
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
}